import { useNavigate } from "react-router-dom";

import AddCardIcon from "@mui/icons-material/AddCard";
import ConnectingAirportsIcon from "@mui/icons-material/ConnectingAirports";
import FlightIcon from "@mui/icons-material/Flight";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { Grid, Typography } from "@mui/material";

const Guides = () => {
  const navigator = useNavigate();

  const menus = [
    {
      path: "/guides/flights",
      name: "How Real-time Search Works",
      icon: <FlightIcon color="primary" className="rotate-[45deg] mr-[10px]" />,
      imgUrl: "https://img.awardtool.com/guides/real-time-search.png",
      desc: "Use real-time search engine to find the best use of your points.",
    },
    {
      path: "/guides/routes",
      name: "How Panorama Feature Works",
      icon: <ConnectingAirportsIcon color="primary" className="mr-[10px]" />,
      imgUrl: "https://img.awardtool.com/guides/routes_guide_c.jpg",
      desc: "Search flight availability by region and range, and check calendar view of popular routes.",
    },
    {
      path: "/guides/alerts",
      name: "How Award Alert Works",
      icon: <NotificationsIcon color="primary" className="mr-[10px]" />,
      imgUrl: "https://img.awardtool.com/guides/alerts_email.png",
      desc: "Don't miss a flight by setting award alert.",
    },
    {
      path: "/guides/hotels",
      name: "How Award Hotels Works",
      icon: <NotificationsIcon color="primary" className="mr-[10px]" />,
      imgUrl: "https://img.awardtool.com/guides/guide_page.jpg",
      desc: "Elevate your award travel experience with selected top-notch hotel stays.",
    },
    {
      path: "/guides/amextransfer",
      name: "Amex Transfer Guide",
      icon: <AddCardIcon color="primary" className="mr-[10px]" />,
      imgUrl: "https://img.awardtool.com/guides/amex-transfer.png",
      desc: "A guide on transfer Amex Membership Rewards.",
    },
    {
      path: "/guides/bilttransfer",
      name: "Bilt Transfer Guide",
      icon: <AddCardIcon color="primary" className="mr-[10px]" />,
      imgUrl: "https://img.awardtool.com/guides/Bilt4.PNG",
      desc: "A guide on transfer Bilt Rewards.",
    },
    {
      path: "/guides/chasetransfer",
      name: "Chase Transfer Guide",
      icon: <AddCardIcon color="primary" className="mr-[10px]" />,
      imgUrl: "https://img.awardtool.com/guides/chase_guide_cover.jpg",
      desc: "A guide on transfer Chase Ultimate Rewards.",
    },
    {
      path: "/guides/capitalonetransfer",
      name: "Capital One Transfer Guide",
      icon: <AddCardIcon color="primary" className="mr-[10px]" />,
      imgUrl: "https://img.awardtool.com/guides/cap1_1_2.jpg",
      desc: "A guide on transfer Capital One Miles Rewards.",
    },
    {
      path: "/guides/cititransfer",
      name: "Citi Transfer Guide",
      icon: <AddCardIcon color="primary" className="mr-[10px]" />,
      imgUrl: "https://img.awardtool.com/guides/citi_guide.jpg",
      desc: "A guide on transfer Citi Thankyou Points.",
    },
    // {
    //   path: "/guides/advertiser",
    //   name: "Advertiser Disclosure",
    //   icon: <AddCardIcon color="primary" className="mr-[10px]" />,
    // },
  ];

  return (
    <div className="p-[10px]">
      <Grid container spacing={2} rowSpacing={5}>
        {menus.map((item) => (
          <Grid
            item
            sm={6}
            md={4}
            lg={3}
            xs={12}
            key={item.name}
            onClick={() => navigator(item.path)}
            className="cursor-pointer"
          >
            <div
              className="rounded-md w-[100%] h-[220px] min-[700px]:h-[180px] bg-no-repeat min-[700px]:bg-center bg-cover mb-[10px]"
              style={{
                backgroundImage: `url(${item.imgUrl})`,
              }}
            />
            <Typography sx={{ fontWeight: 600 }}>{item.name}</Typography>
            <Typography>{item.desc}</Typography>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default Guides;
